import React from 'react';

import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
} from '@mui/material';

const SelectField = ({
  id,
  fullWidth,
  label,
  value,
  placeholder,
  options,
  onChange,
  textAlign = 'center',
}) => {
  return (
    <FormControl fullWidth={fullWidth}>
      <InputLabel id={id}>{label}</InputLabel>
      <Select
        labelId={id}
        id={id}
        value={value}
        input={
          <OutlinedInput
            id={id}
            label={label}
            sx={{ textAlign }}
          />
        }
        onChange={onChange}>
        {placeholder ? (
          <MenuItem value=''>
            <em>{placeholder}</em>
          </MenuItem>
        ) : null}
        {options.length
          ? options.map((option) => (
              <MenuItem
                key={`${id}_${option.id}`}
                value={option.value}>
                {option.text}
              </MenuItem>
            ))
          : null}
      </Select>
    </FormControl>
  );
};

export default SelectField;
